import { useEffect, useState } from 'react'
import { _years } from '../../../modules/admin/perfil/elements/PayrollProcess'
import { _single } from '../../services/dataBean/EntityCatalog'


interface YearSelectorProps {
    onChange: (value: any) => void
    value?: any
    disabled?: boolean
    size?: 'sm' | 'md' | 'lg'
    tittle?: string
    currentTerm?: boolean
    returnAs?: 'number' | 'string'
}


export const YearSelector = ({
    value,
    disabled,
    onChange,
    size = 'md',
    tittle,
    currentTerm = false,
    returnAs = 'number',
}: YearSelectorProps) => {

    const [val, setVal] = useState(null)

    const currentYear = _single.getCurrenYear()

    let years = [..._years]

    if (!years.includes(currentYear + 1)) {
        years.push(currentYear + 1)
    }

    const availableYears = currentTerm
        ? years.filter(y => y === currentYear || y === currentYear + 1)
        : years

    useEffect(() => {
        let year = value ?? currentYear

        if (currentTerm && year > currentYear + 1) {
            year = currentYear
        }

        setVal(year)

        if (onChange) {
            if (returnAs === 'number') {
                onChange(year)
            } else {
                onChange(String(year))
            }
        }

    }, [value, currentTerm])

    const setValue = (year) => {
        setVal(year)

        if (!onChange) return

        if (year == null) {
            onChange(null)
            return
        }

        if (returnAs === 'number') {
            onChange(year)
        } else {
            onChange(String(year))
        }
    }

    return (
        <>
            <label>{tittle ?? "Año"}</label>
            <select
                className={`form-select form-select-${size}`}
                disabled={disabled}
                value={val ?? ""}
                onChange={(e) => {
                    const newValue =
                        e.target.value === "" ? null : parseInt(e.target.value)
                    setValue(newValue)
                }}
            >
                <option value="">...</option>

                {availableYears.map((year) => (
                    <option value={year} key={year}>
                        {year}
                    </option>
                ))}
            </select>
        </>
    )
}
